<div class="steps">
  @for (link of navigationItems; track link) {
  <div class="navigation-item" [ngClass]="[link.isActive ? 'active' : '']">
    <div class="navigation-item-container">
      <!-- The icon content is filled through css -->
      <mat-icon></mat-icon>
      <span>{{ link.text }}</span>
    </div>
    <div class="vertical-line"></div>
  </div>
  }
</div>
